// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
// import StoreProductDetailsInformations from "@store/Library/Components/Foundation/StoreProduct/StoreProductDetailsInformations"; - bunzl custom code

// Store Custom Code
import StoreProductDetailsInformations from "@store/Library/Components/Overrides/StoreProduct/StoreProductDetailsInformations";
import React from "react";

const enum fields {
    disableOutOfStockVariants = "disableOutOfStockVariants",
    showSizingChart = "showSizingChart",
    showSeriesBadge = "showSeriesBadge",
    seriesBadgeWidth = "seriesBadgeWidth",
    attributes = "attributes",
    attributeName = "attributeName",
    fallbackOnNormalAttributeType = "fallbackOnNormalAttributeType",
    // Store Custom Code
    disableSwatchGrid = "disableSwatchGrid",
}

const enum fieldsEnum {
    attributeName = "attributeName",
}

export type AttributeModel = {
    fields: {
        [fieldsEnum.attributeName]: string;
    };
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.disableOutOfStockVariants]: boolean;
        [fields.showSizingChart]: boolean;
        [fields.showSeriesBadge]: boolean;
        [fields.seriesBadgeWidth]: number;
        [fields.attributes]: AttributeModel[];
        [fields.fallbackOnNormalAttributeType]: boolean;
        // Store Custom Code
        [fields.disableSwatchGrid]: boolean;
    };
}

const ProductDetailsInformations: React.FC<OwnProps> = ({ fields, id }) => {
    return (
        <StoreProductDetailsInformations
            // Store Custom Code
            disableSwatchGrid={fields.disableSwatchGrid}
            disableOutOfStockVariants={fields.disableOutOfStockVariants}
            showSizingChart={fields.showSizingChart}
            showSeriesBadge={fields.showSeriesBadge}
            seriesBadgeWidth={fields.seriesBadgeWidth}
            selectedAttributes={fields.attributes?.map(x => x.fields[fieldsEnum.attributeName]) || []}
            fallbackOnNormalAttributeType={fields.fallbackOnNormalAttributeType}
            widgetId={id}
        />
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsInformations,
    definition: {
        group: "Product Details",
        displayName: "Product Details Informations",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.disableOutOfStockVariants,
                displayName: "Disables the variants that are out of stock.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
            {
                name: fields.showSizingChart,
                displayName: "Shows the sizing charts.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
            {
                name: fields.showSeriesBadge,
                displayName: "Shows the series badges.",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
            {
                name: fields.seriesBadgeWidth,
                displayName: "Series badge width",
                editorTemplate: "IntegerField",
                fieldType: "General",
                defaultValue: 35,
                isRequired: false,
                tooltip: "the width is in px.",
                isVisible: widget => widget.fields.showSeriesBadge,
            },
            {
                name: fields.attributes,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.attributeName;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: fieldsEnum.attributeName,
                        displayName: "Tap the attribute you want to display",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.fallbackOnNormalAttributeType,
                displayName: "Fallback on the normal attribute types order if the one selected are not found",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            // Store Custom Code
            {
                name: fields.disableSwatchGrid,
                displayName: "Disables swatch grid display",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: false,
            },
        ],
    },
};

export default widgetModule;
